import { Card, Splitter, Tabs, Typography } from 'antd'
import React from 'react'
import DepartmentPage from '../../../components/Manage/EmpoyeManage/Department/DepartmentPage'
import EmployessPage from '../../../components/Manage/EmpoyeManage/Employess/EmployessPage'
import UserManage from '../Users/UserManage'
import RolePage from '../../../components/Manage/EmpoyeManage/Roles/RolePage'
import ViewByDepartment from './ViewByDepartment'

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const EmployeesPage = () => {

    const perm = getPermission('/manage-employees');

    const items = [
        {
            key: "1",
            label: "Departments",           
            children: <DepartmentPage />,
        },
        {
            key: "3",
            label: "Roles",
            children: <RolePage />,
        },
        {
            key: "2",
            label: "Employees",
            children: <UserManage />,
        },
         {
            key: "4",
            label: "Department Overview",
            children: <ViewByDepartment />,
        },
        
    ]


if (!perm.read) {
        return (
            <Card title={<Typography.Title level={4}>Manage Employees</Typography.Title>}>
                <Typography.Text type="secondary">You don't have permission to view this page.</Typography.Text>
            </Card>
        );
    }

    return (
        <>
            <Card
                title={<Typography.Title level={4} >Manage Employees</Typography.Title>}>

                <Tabs
                    tabPosition="left"
                    size="large"
                    defaultActiveKey="1"
                    items={items}
                />
            </Card>
        </>
    )
}

export default EmployeesPage
